module.exports = __webpack_public_path__ + "img/200-2.ded7aadc.gif";